import React from "react";
import { Box, Button } from "@mui/material";
import isMobile from "../isMobile";

const ClearAllButton = ({ clearAll }) => {
  const mobileView = isMobile();
  return (
    <Box sx={{ textAlign: "center", m: 3 }}>
      <Button size={mobileView ? "small" : "medium"} variant="outlined" color="error" onClick={clearAll}>
        Clear All Items
      </Button>
    </Box>
  );
};

export default ClearAllButton;
